import './bootstrap';
import './image-protection';

import intlTelInput from 'intl-tel-input';
window.intlTelInput = intlTelInput;

import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import localeCn from 'air-datepicker/locale/zh';
import localeEn from 'air-datepicker/locale/en';
window.AirDatepicker = AirDatepicker;
window.localeCn = localeCn;
window.localeEn = localeEn;

import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
window.Plyr = Plyr;

import select2 from 'select2';
import 'select2/dist/css/select2.css';
select2($);

import Swiper from 'swiper';
window.Swiper = Swiper;

import { Navigation, Pagination, Autoplay, Thumbs, FreeMode } from 'swiper/modules';
window.Navigation = Navigation;
window.Pagination = Pagination;
window.Autoplay = Autoplay;
window.Thumbs = Thumbs;
window.FreeMode = FreeMode;
import "swiper/swiper-bundle.css";

// --- AOS only if any [data-aos] exists
if ( document.querySelector('[data-aos]') ) {
    (async () => {
        await import('aos/dist/aos.css')
        const AOS = (await import('aos')).default
        AOS.init()
        window.addEventListener('load', AOS.refresh)
    })()
}

// --- SweetAlert2: lazy-load on first use
window.Swal = {
    _lib: null,
    async fire(...args) {
        if (!this._lib) {
            await import('sweetalert2/src/sweetalert2.scss')
            this._lib = (await import('sweetalert2/dist/sweetalert2.js')).default
        }
        return this._lib.fire(...args)
    },
}

// Header Scroll Down & Up Animation
document.addEventListener('DOMContentLoaded', function() {
    const navbar = document.getElementById('header_section');
    const burger = document.getElementById('nav-icon4');
    const menu = document.getElementById('navbarMenu');
    const scrollThreshold = 10;

    window.addEventListener('scroll', function() {
        if (window.scrollY > scrollThreshold) {
            navbar.classList.add('scrolled');
        } else {
            navbar.classList.remove('scrolled');
        }
    });

    burger.addEventListener('click', function() {
        burger.classList.toggle('open');
        menu.classList.toggle('active');
    });
});